<template lang="html">
  <root class="admin-view-business">

    <admin-nav></admin-nav>
    <page-header name="View business" :count="false"></page-header>

    <preloader :is-active="!display_photo && !cover_photo"></preloader>

    <!-- Data -->
    <div class="container">
      <div class="row">
        <div class="col m6 offset-m3">
          <table class="striped" v-if="business && display_photo && cover_photo">
            <tbody>
              <tr>
                <th>Display photo</th>
                <td><img v-if="display_photo" :src="display_photo" alt=""></td>
              </tr>
              <tr>
                <th>Cover photo</th>
                <td><img v-if="cover_photo" :src="cover_photo" alt=""></td>
              </tr>
              <tr>
                <th>Name (EN)</th>
                <td>{{ business.name.en }}</td>
              </tr>
              <tr>
                <th>Name (AR)</th>
                <td>{{ business.name.ar }}</td>
              </tr>
              <tr>
                <th>Description (EN)</th>
                <td>{{ business.description.en }}</td>
              </tr>
              <tr>
                <th>Description (AR)</th>
                <td>{{ business.description.ar }}</td>
              </tr>
              <tr>
                <th>Country</th>
                <td class="uppercase">{{ business.country }}</td>
              </tr>
              <tr>
                <th>Cities</th>
                <td>
                  <li v-if="business.cities" v-for="city in business.cities">{{ city }}</li>
                </td>
              </tr>
              <tr>
                <th>Delivery time</th>
                <td>{{ business.delivery_time.en }}</td>
              </tr>
              <tr>
                <th>Dishes</th>
                <td>{{ business.dishes }}</td>
              </tr>
              <tr>
                <th>Ratings</th>
                <td>{{ _.round(business.rating, 2) }}</td>
              </tr>
              <tr>
                <th>Open</th>
                <td>{{ business.is_open ? 'Open' : 'Closed' }}</td>
              </tr>
              <tr>
                <th>Verified</th>
                <td>{{ business.is_verified ? 'Yes' : 'No' }}</td>
              </tr>
              <tr>
                <th>Share URL</th>
                <td>
                  <a :href="'https://awaniapp.com/b/' + business.deeplink_hash" target="_blank" v-if="business.deeplink_hash">https://awaniapp.com/b/{{ business.deeplink_hash }}</a>
                  <small v-else>No deeplink hash</small>
                </td>
              </tr>
              <tr>
                <th>Created at</th>
                <td>{{ new Date(business.timestamp).toLocaleString() }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

  </root>
</template>

<script>
import * as firebase from "firebase";
//const purify = (x) => JSON.parse(JSON.stringify(x));

export default {
  data() {
    return {
      business: {
        name: {
          en: "",
          ar: "",
        },
        description: {
          en: "",
          ar: "",
        },
      },

      display_photo: "",
      cover_photo: "",
    };
  },
  methods: {
    collectBusiness() {
      firebase
        .database()
        .ref("businesses/" + this.$route.params.businessKey)
        .once("value")
        .then((businessSnap) => {
          let dishesSnap = businessSnap.child("dishes");
          let ratingsSnap = businessSnap.child("ratings");
          let totalRating = 0;

          // Data
          let businessData = businessSnap.val();

          //console.log(purify(businessData));

          businessData["dishes"] = dishesSnap.numChildren();

          // Cities
          let businessCities = businessSnap.child("cities");
          businessData["cities"] = [];

          // Ratings
          ratingsSnap.forEach((ratingSnap) => {
            totalRating += ratingSnap.val().rate;
          });
          businessData["rating"] = totalRating / 3;

          // Bind
          this.business = businessData;

          // Cities
          businessCities.forEach((city) => {
            firebase
              .database()
              .ref(
                "countries/" + businessData.country + "/cities/" + city.val()
              )
              .once("value")
              .then((citySnap) => {
                this.business.cities.push(citySnap.val().name.en);
              });
          });

          //console.log(businessData.old_key);

          // Display photo
          var displayPhotoKey = null;
          if (businessData.is_display_photo_updated == true) {
            displayPhotoKey = businessSnap.key;
          } else {
            displayPhotoKey = businessData.old_key;
          }
          firebase
            .storage()
            .ref("business/display/" + displayPhotoKey + ".jpeg")
            .getDownloadURL()
            .then((display) => {
              this.display_photo = display + ".jpeg";
            })
            .catch((error) => {
              // A full list of error codes is available at
              // https://firebase.google.com/docs/storage/web/handle-errors
              switch (error.code) {
                case "storage/object-not-found":
                  console.log("File doesn't exist");
                  break;
                case "storage/unauthorized":
                  console.log(
                    "User doesn't have permission to access the object"
                  );
                  break;
                case "storage/canceled":
                  console.log("User canceled the upload");
                  break;
                case "storage/unknown":
                  console.log(
                    "Unknown error occurred, inspect the server response"
                  );
                  break;
              }
            });

          // Cover photo
          var coverPhotoKey = null;
          if (businessData.is_cover_photo_updated == true) {
            coverPhotoKey = businessSnap.key;
          } else {
            coverPhotoKey = businessData.old_key;
          }
          firebase
            .storage()
            .ref("business/cover/" + coverPhotoKey + ".jpeg")
            .getDownloadURL()
            .then((cover) => {
              this.cover_photo = cover + ".jpeg";
            })
            .catch((error) => {
              // A full list of error codes is available at
              // https://firebase.google.com/docs/storage/web/handle-errors
              switch (error.code) {
                case "storage/object-not-found":
                  console.log("File doesn't exist");
                  break;
                case "storage/unauthorized":
                  console.log(
                    "User doesn't have permission to access the object"
                  );
                  break;
                case "storage/canceled":
                  console.log("User canceled the upload");
                  break;
                case "storage/unknown":
                  console.log(
                    "Unknown error occurred, inspect the server response"
                  );
                  break;
              }
            });
        });
    },
  },
  mounted() {
    this.collectBusiness();
  },
};
</script>

<style lang="scss">
.admin-view-business {
  img {
    max-height: 75px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/BusinessView.vue